<template>
  <div class="footer">
    <div class="footer-logo">
      <img src="../assets/img/index-logo.jpg" alt="京麦通" />
      <!-- <p>京麦通</p> -->
    </div>
    <div class="footer-link">
      客服1：
      <a target="_blank" href="tencent://message/?uin=431142626&Menu=yes&Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45">
        <img style="width:90px;" border="0" src="../assets/img/button_qq.gif" alt="点击这里给我发消息" title="点击这里给我发消息">
      </a>
      <!-- tencent://message/?uin=输入QQ号&Site=http://vps.shuidazhe.com&Menu=yes -->
      <!-- href="http://wpa.qq.com/msgrd?V=3&Uin=123456&Site=[Discuz!]&from=discuz&Menu=yes" -->
<!-- href="http://wpa.qq.com/msgrd?v=3&uin=431142626&site=qq&menu=yes" -->
<!-- http://wpa.qq.com/msgrd?v=3&uin=384195132&site=qq&menu=yes -->
<!-- tencent://message/?uin=1234567&Menu=yes& Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45 -->
      <span>|</span>
      客服2：
      <a target="_blank" href="tencent://message/?uin=384195132&Menu=yes&Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45">
        <img style="width:90px;" border="0" src="../assets/img/button_qq.gif" alt="点击这里给我发消息" title="点击这里给我发消息">
      </a>
    </div>
    <div class="footer-link">
      <a href="/home">QQ: 431142626（AM 9:00 - 12:00 PM 13:00 - 18:00）</a><span>|</span>
      <a href="/home">TEL: 18611489018</a><span>|</span>
      <a href="/home">
        图书品种 <strong>500万</strong></a>
    </div>
    <div class="copyright">
      © 2018-2028 北京京麦通科贸有限公司 
      <!-- 北京京麦通科贸有限公司 -->
      <a style="text-decoration:none;color: #000000" href="https://beian.miit.gov.cn"
        target="_blank">
        京ICP备18052185号-1
      </a>
      <!-- 京ICP备18052185号 -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 200px;
  border-top: 2px solid #5cadff;
  background: #f2f2f2;
  color: #333333;
  font-size: 16px;
  text-align: center;
  .footer-logo {
    margin: 16px 0 16px 0;
    img {
      width: 90px;
      margin: 0 auto;
      height: 36px;
      margin-bottom: 13px;
    }
  }
  .footer-link {
    a {
      color: #333333;
      display: inline-block;
    }
    span {
      margin: 0 10px;
    }
    img{
      margin-bottom: -5px;
    }
    margin-bottom: 10px;
  }
//   .copyright {
//     .domain {
//       color: $colorA;
// //     }
//   }
}
</style>
